import {
  UserByPhoneNumberUrl,
  CompanyDetailsByPhoneNumberUrl,
  AddDistributorInvoiceUrl,
  UploadInvoiceFiles,
  GetUserInvoiceUrl,
  GetInventoryUrl,
  GetSingleProductUrl,
  GetTransactionUrl,
  AddDistributorSellInvoiceUrl,
  GetUserInvoiceFileUrl,
  UploadUserFilesUrl,
  GetUserInvoiceUploadsUrl,
  AllCompanyUrl,
  AllProductsUrl,
  CompanyTypesUrl,
  orderInvoiceDataUrl,
  orderInvoiceFilesUploadUrl,
  orderRemainingProductsUrl,
  getPaginatedOrdersUrl,
  getBannerImagesUrl,
  EditDistributorInvoiceUrl,
  GetUserInvoicePaginUrl,
  GetUserTransactionOverviewUrl,
  GetUserTransactionDetailsUrl,
  GetUserTransactionDetailsByBuyerUrl,
  GetUserTransactionDetailsBrandUrl,
  GetCompanyWiseInventoryDataUrl,
  GetProductWiseinventoryDataUrl,
  SendOtpToGiftRecieverUrl,
  VerifyOtpToGiftRecieverUrl,
  GetAnnouncedGiftsProductsListUrl,
  UploadGiftImageUrl,
  SendOtpToMasonGiftRecieverUrl,
  UpdateGiftStatusUrl,
  deleteInvoiceFileUrl,
  EditVerifiedInvoicesUrl,
  getBenefitsDataOfUserUrl,
  addPersonalProfilerUrl,
  editPersonalProfilerUrl,
  addBusinessProfilerUrl,
  editBusinessProfilerUrl,
  getAllPersonalProfilerUrl,
  getAllBusinessProfilerUrl,
  editBusinessProfilerrUrl,
  registerNotificationTokenUrl,
  deleteNotificationTokenUrl,
  GetUserInsuranceCertificateUrl,
  GetAllUserInsuranceCertificateUrl,
  GetMyRetailersGiftTransactionsUrl,
  GetNotificationPaginUrl,
  GetCompanyProductInventoryWithIdUrl,
  GetCompanyBenefitsUrl,
  CompanyDetailsByCompanyNameUrl,
  getPhoneNumberViaGstinUrl,
  getPhoneNumberViaPanUrl,
  getLedgerDueAmountUrl,
  CreateLedgerPaymentUrl,
  getLedgerBalanceUrl,
  getLedgerTransUrl,
  updateLedgerPaymentUrl,
  getOrderInvoicesUrl,
  getAllOrderInvoicesUrl,
  totalSaleTotalBuyReportsUrl,
  monthlySaleTotalBuyReportsUrl,
  sellProductWithProductCompanyIdUrl,
  getReportsCSVFileUrl,
  getDispatchPlanningReportUrl,
  getReportsCSVFileForRetailerUrl,
  GetGapDetailsListUrl,
  getAmountForMedicalInsuranceUrl,
  getAddressOfDeliveryToUserUrl,
  getCheckIfLedgerBalanceFileUrl,
  getKnowYouBetterUrl,
  getAllGenderUrl,
  getAllQualificationUrl,
  getAllRelationshipUrl,
  getAllLanguagesUrl,
  getAllBloodGroupUrl,
  getAllHealthConcernsUrl,
  getAllMealsUrl,
  addKnowYouBetterUrl,
  editKnowYouBetterUrl,
  getSkuMasterUrl,
  getUserInventoryTransactionsStpInfoUrl,
  searchCompanyUrl,
} from '../api';
import { axios, dateFormat } from '../../../utils/settings';
import {
  getTokenHeader,
  getToken,
  getTokenHeaderFile,
} from '../../auth/action';
import notification from 'antd/lib/notification';
import moment from 'moment';

export const GetUserByPhoneNumber = async (phone_number) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${UserByPhoneNumberUrl()}/${phone_number}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetCompanyDetailsByPhoneNumber = async (phone_number, params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${CompanyDetailsByPhoneNumberUrl()}/${phone_number}`, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const searchCompanyAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        searchCompanyUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAddressOfDeliveryToUser = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getAddressOfDeliveryToUserUrl()}?deliver_to_company_id=${id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getOrderInvoicestAction = (id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getOrderInvoicesUrl()}?order_id=${id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPhoneNumberViaGstinAction = async (gstin) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${getPhoneNumberViaGstinUrl()}?gstin=${gstin}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPhoneNumberViaPanAction = async (pan) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${getPhoneNumberViaPanUrl()}?pancard_no=${pan}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getTotalSaleTotalReportsBuy = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${totalSaleTotalBuyReportsUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const getDispatchPlanningReportAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getDispatchPlanningReportUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const getReportsCSVFileAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getReportsCSVFileUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async (x) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};
export const getReportsCSVFileForRetailerAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getReportsCSVFileForRetailerUrl()}`, {
        params: {},
        ...getTokenHeader(token),
      })
      .then(async (x) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};

export const getMonthlySaleTotalReportBuy = async ({ year, month }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${monthlySaleTotalBuyReportsUrl()}?year=${year}&month=${month}
      `,
        {
          params: {},
          ...getTokenHeader(token),
        },
      )
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        return next({ error: error });
      });
  });
};

export const GetCompanyDetailsByCompanyName = async (string) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${CompanyDetailsByCompanyNameUrl()}?company_name=${string}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const AddDistributorInvoice = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${AddDistributorInvoiceUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const EditDistributorInvoice = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(`${EditDistributorInvoiceUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const EditVerifiedInvoices = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${EditVerifiedInvoicesUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const AddInvoiceFiles = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${UploadInvoiceFiles()}`, data, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getCompanies = async (name, params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${AllCompanyUrl()}/?company_name=${name}`, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getProducts = async ({ companyId, pincode }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let url;
    // if (pincode) {
    //   url = `${AllProductsUrl()}/?company_id=${companyId}&pincode=${pincode}`;
    // } else {
    url = `${AllProductsUrl()}/?company_id=${companyId}`;
    // }
    // console.log(
    //   `${AllProductsUrl()}?company_id=${companyId}&pincode=${pincode}`,
    // );

    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetUserInvoiceData = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetUserInvoiceUrl()}`, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserInvoicePaginData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetUserInvoicePaginUrl(), {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
// Only for Gist to check inventory
export const GetUserInvoicePagin = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${GetUserInvoicePaginUrl()}?f=transaction_type$eq$SELL&f=invoice_state$eq$VERIFIED&f=date_of_invoice$gte$${
          data.startDate
        }&f=date_of_invoice$lte$${data.endDate}&o=date_of_invoice$desc&page=${
          data.page
        }&page_size=10&first_party=true`,
        {
          ...getTokenHeaderFile(token),
        },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetSingleProductData = async (product_id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${GetSingleProductUrl()}/${product_id}`, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetInventoryData = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetInventoryUrl()}`, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetCompanyWiseInventoryData = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetCompanyWiseInventoryDataUrl()}?company_esi_id=${company_esi_id}`, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetCompanyProductInventoryWithId = async (id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${GetCompanyProductInventoryWithIdUrl()}?product_company_id=${id}`,
        getTokenHeaderFile(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetProductWiseinventoryData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetProductWiseinventoryDataUrl()}`, {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetTransactionData = async (transaction_type, product_id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${GetTransactionUrl()}?transaction_type=${transaction_type}&product_id=${product_id}`,
        getTokenHeaderFile(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetInvoiceFilesAction = async (invoice_id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${GetUserInvoiceFileUrl()}/${invoice_id}`,
        getTokenHeaderFile(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const deleteInvoiceFile = async (invoice_id) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(
        `${deleteInvoiceFileUrl()}?invoice_id=${invoice_id}`,
        getTokenHeaderFile(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const AddDistributorSellInvoice = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${AddDistributorSellInvoiceUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const sellProductWithProductCompanyIdAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${sellProductWithProductCompanyIdUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const UploadUserFiles = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(UploadUserFilesUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetDownloadFileAction = async (file_id, file_name, file_type) => {
  try {
    let token = await getToken();
    fetch(`${GetUserInvoiceUploadsUrl()}/${file_id}?file_type=${file_type}`, {
      method: 'GET',
      ...getTokenHeader(token),
    }).then(function (t) {
      return t.blob().then((b) => {
        if (b.type.includes('application/json')) {
          return notification.error({ message: 'No Invoice File Found' });
        }
        let a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', file_name);
        a.click();
      });
    });
  } catch (err) {
    console.log(err);
  }
};

export const getComapanyTypes = async ({ types }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${CompanyTypesUrl()}/`,
        { company_types: types },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getRetailers = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${CompanyTypesUrl()}/`,
        { company_types: [3] },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const orderInvoiceData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${orderInvoiceDataUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const orderInvoiceFilesUpload = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${orderInvoiceFilesUploadUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const orderRemainingProducts = async ({ orderId }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${orderRemainingProductsUrl()}?order_id=${orderId}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPaginatedOrders = async ({
  page,
  pageSize,
  f,
  orderStatus,
  cancelled,
  isForPartialDispatch = false,
  seller_id,
}) => {
  return new Promise(async (next) => {
    let token = await getToken();

    let url;

    if (cancelled) {
      url = `${getPaginatedOrdersUrl()}?f=status$eq$${orderStatus}&f=date$gte$${moment()
        .subtract(10, 'days')
        .format(dateFormat)}&f=date$lte$${moment()
        .add(1, 'days')
        .format(
          dateFormat,
        )}&o=date$desc&o=id$desc&page=${page}&page_size=${pageSize}`;
      if (seller_id) {
        url = url + `&f=seller_id$eq$${seller_id}`;
      }
    } else if (isForPartialDispatch) {
      url = `${getPaginatedOrdersUrl()}?f=${f}&id$gte$0&o=date$desc&o=id$desc&page=${page}&page_size=${pageSize}&is_buyer=true`;
      if (seller_id) {
        url = url + `&f=seller_id$eq$${seller_id}`;
      }
    } else {
      url = `${getPaginatedOrdersUrl()}?f=${f}&f=order_approval$eq$${orderStatus}&id$gte$0&o=date$desc&o=id$desc&page=${page}&page_size=${pageSize}&is_buyer=true`;
      if (seller_id) {
        url = url + `&f=seller_id$eq$${seller_id}`;
      }
    }

    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllOrderInvoicesAction = async ({ page, end, start }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    let url;

    if (end && start) {
      url = `${getAllOrderInvoicesUrl()}?f=id$gte$0&f=date_of_invoice$gte$${start}&f=date_of_invoice$lte$${end}&o=date_of_invoice$desc&o=id$desc&page=${page}&page_size=10&first_party=true
      `;
    } else {
      url = `${getAllOrderInvoicesUrl()}?f=id$gte$0&o=date_of_invoice$desc&o=id$desc&page=${page}&page_size=10&first_party=true`;
    }
    console.log(end, start, 'api', url);

    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getOrderDetails = async ({ id }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(
        `${getPaginatedOrdersUrl()}?f=id$eq$${id}&o=date$desc&o=id$desc&page=1&page_size=1`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getBannerImages = async () => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getBannerImagesUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetUserTransactionOverviewNow = (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetUserTransactionOverviewUrl()}`, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserTransactionDetailsNow = (transactionType, phoneNumber) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let url = GetUserTransactionDetailsUrl();
    url += `?transaction_type=${transactionType}`;
    url += phoneNumber ? `&buy_or_sell_to_ph_number=${phoneNumber}` : '';
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserTransactionDetailsByBuyerNow = (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetUserTransactionDetailsByBuyerUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getUserInventoryTransactionsStpInfoAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        getUserInventoryTransactionsStpInfoUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserTransactionDetailsBrandNow = (
  transactionType,
  buyer_or_sell_to,
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let url = GetUserTransactionDetailsBrandUrl();
    url += `?buy_or_sell_to=${buyer_or_sell_to}&transaction_type=${transactionType}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// Gifts Url
export const SendOtpToGiftReciever = (transactionId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${SendOtpToGiftRecieverUrl()}?transaction_id=${transactionId}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const VerifyOtpToGiftReciever = (transactionId, otp) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${VerifyOtpToGiftRecieverUrl()}?transaction_id=${transactionId}&otp=${otp}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetAnnouncedGiftsProductsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${GetAnnouncedGiftsProductsListUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetMyRetailersGiftTransactionsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${GetMyRetailersGiftTransactionsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const UploadGiftImage = async (transactionId, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${UploadGiftImageUrl()}?transaction_id=${transactionId}`, data, {
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json',
          'content-type': 'multipart/form-data;',
        },
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendOtpToMasonGiftReciever = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${SendOtpToMasonGiftRecieverUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const UpdateGiftStatus = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${UpdateGiftStatusUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// benefits
export const getBenefitsDataOfUser = async (name) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getBenefitsDataOfUserUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

//Personal Profilers
export const addPersonalProfiler = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${addPersonalProfilerUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const addKnowYouBetter = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${addKnowYouBetterUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const editPersonalProfiler = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(`${editPersonalProfilerUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const editKnowYouBetter = async (data) => {
  console.log('data', data);
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(`${editKnowYouBetterUrl(data.id)}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllPersonalProfile = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllPersonalProfilerUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

//know you better profiler
export const getKnowYouBetterProfiler = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getKnowYouBetterUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllGender = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllGenderUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllQualification = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllQualificationUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllRelationship = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllRelationshipUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllLanguages = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllLanguagesUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllBloodGroup = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllBloodGroupUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllHealthConcerns = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllHealthConcernsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllMeals = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllMealsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
//Business Profilers
export const addBusinessProfiler = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${addBusinessProfilerUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const editBusinessProfiler = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${editBusinessProfilerrUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAllBusinessProfiler = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAllBusinessProfilerUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

//Notification
export const registerNotificationToken = async (userToken, data) => {
  console.log('userToken', userToken);
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${registerNotificationTokenUrl(userToken)}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const deleteRegisterNotificationToken = async (userToken, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(`${deleteNotificationTokenUrl(userToken)}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetInsuranceCertificateAction = async (file_id, file_name) => {
  try {
    let token = await getToken();
    fetch(`${GetUserInsuranceCertificateUrl()}${file_id}`, {
      method: 'GET',
      ...getTokenHeader(token),
    }).then(function (t) {
      return t.blob().then((b) => {
        if (b.type.includes('application/json')) {
          return notification.error({ message: 'No Certificate Found' });
        }
        let a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', file_name);
        a.click();
      });
    });
  } catch (err) {
    console.log(err);
  }
};

export const GetAllUserInsuranceCertificate = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetAllUserInsuranceCertificateUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getAmountForMedicalInsurance = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAmountForMedicalInsuranceUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetCompanyBenefitsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetCompanyBenefitsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// paginated notifications
export const GetNotificationsPaginData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetNotificationPaginUrl(), {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getLedgerDueAmountAction = ({ seller_id, supplier_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getLedgerDueAmountUrl()}?seller_id=${seller_id}&supplier_id=${supplier_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getCheckIfLedgerBalanceFile = () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getCheckIfLedgerBalanceFileUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const CreateLedgerPayment = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${CreateLedgerPaymentUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getLedgerBalanceAction = () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getLedgerBalanceUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getLedgerTransAction = ({
  seller_id,
  page,
  isCredit,
  monthFilter,
  status = 'COMPLETED',
}) => {
  return new Promise(async (next) => {
    let token = await getToken();
    // &f=status$eq$COMPLETED
    let urlString = `${getLedgerTransUrl()}?seller_id=${seller_id}&f=id$gte$0&o=id$desc&page=${page}&page_size=10&payment_filter=false`;
    if (isCredit) {
      urlString = `${getLedgerTransUrl()}?seller_id=${seller_id}&f=id$gte$0&f=status$eq$${status}&o=id$desc&page=${page}&page_size=10&f=transaction_type$eq$CREDIT&payment_filter=true`;
      if (monthFilter.start && monthFilter.end) {
        urlString = `${getLedgerTransUrl()}?seller_id=${seller_id}&f=id$gte$0&f=status$eq$${status}&f=last_updated$gte$${
          monthFilter.start
        }&f=last_updated$lte$${
          monthFilter.end
        }&o=id$desc&page=${page}&page_size=10&f=transaction_type$eq$CREDIT&payment_filter=true`;
      }
    }
    await axios
      .get(urlString, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateLedgerPayment = async (txnid) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .patch(`${updateLedgerPaymentUrl()}`, txnid, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// gap listings
export const GetGapDetailsList = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetGapDetailsListUrl()}`, {
        params,
        ...getTokenHeaderFile(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getSkuMaster = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getSkuMasterUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
